import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";
import { BILLING_TYPE } from '../../../state/invoice/InvoiceBillingType';

class InvoiceFullyPaidEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            invoice: this.props.invoice || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            invoice: nextProps.invoice || null,
        })
    }


    render() {
        return <div className={"row " + this.state.className}>
            <div className={'col-12 d-flex align-items-center'}>
                <div className={'mr-3'}>
                    <h3 className={"m-0 text-success"}>
                        <Icon value={"check-circle"} />
                    </h3>
                </div>
                <div >
                    <p className={'mb-0'}>
                        {this.state.invoice.attributes.billingType !== BILLING_TYPE.RETURN ?
                            <FormattedMessage
                                id="invoice.analytics.events.approved.text"
                                defaultMessage="Invoice {identifier} has been fully paid for a total amount of {amount}"
                                values={{
                                    identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                                    amount: <strong>
                                        <FormattedNumber
                                            value={this.state.invoice.attributes.totalAmount}
                                            style={'currency'}
                                            currency={this.state.invoice.attributes.currency}
                                        />
                                    </strong>,
                                }}
                            /> : <FormattedMessage
                                id="invoice.analytics.events.approved_return.text"
                                defaultMessage="Return {identifier} has been fully refunded for a total amount of {amount}"
                                values={{
                                    identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                                    amount: <strong>
                                        <FormattedNumber
                                            value={Math.abs(this.state.invoice.attributes.totalAmount)}
                                            style={'currency'}
                                            currency={this.state.invoice.attributes.currency}
                                        />
                                    </strong>,
                                }}
                            />
                        }
                    </p>
                </div>
            </div>
        </div>
    }

}

export default InvoiceFullyPaidEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-fully-paid.component.jsx